<template>
<v-container>
  <v-row>
    <v-col style="font-weight:500;">
      <v-row>
        <v-col>
          <span style="font-size:60px; font-weight:bold;"><strong>Agreement concerning data processing by processor in accordance with Art. 28 GDPR</strong></span>
          <br>
          <span style="font-size:20px; font-weight:bold;">Version: March 15th, 2021</span>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>The controller:</strong></span>
            <p>User/customer (Hereinafter referred to as client)</p>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>Subject matter of the agreement:</strong></span>
            <p>Simpleish Technology</p>
            <p>(Hereinafter referred to as contractor)</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>1. Subject of the Contract</strong></span>
            <ul style="list-style-type:none;">
              <li>
                <p>1.1. The subject matter of this agreement is the implementation of the following tasks:</p>
                <p>Automated processing of image data (incl. metadata) as well as integration, monitoring and troubleshooting of image-related processes.</p>
                <p>This agreement is to be considered a supplementary document to the processors General Terms and Conditions.</p>
              </li>
              <li>
                <p>1.2. The following data categories are processed: Contents of image files, their metadata and processing instructions.</p>
              </li>
              <li>
                <p>1.3. The following categories of data subjects are subject to this processing: People that are refered to in data provided by the client, e.g. customers of the client.</p>
              </li>
            </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>2. Duration of the agreement</strong></span>
            <p>The agreement does not have a defined endpoint and can be ended by either party with a notice period of one month on the last day of the month. The option to terminate due to exceptional circumstances remains unaffected.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>3. Obligations of the contractor</strong></span>
            <ul style="list-style-type:none;">
              <li>
                <p>3.1 The contractor commits himself to process the data and the processing results exclusively within the scope of the written assignment of the cliend. Should the contractor be required to release data of the client by request of the authorities, then he has to - as far as it it legally permitted - inform the client of the above without delay and refer the authorities to the client. Likewise, the processing of data for the contractor's own benefit requires written approval by the client.</p>
              </li>
              <li>
                <p>3.2 The contractor declares legally binding that he has obligated all people, assigned to process the data, to adhere to the confidentiality practices, prior to the beginning of the task, or that they are bound by an appropriate, legal non-disclosure obligation. The non-disclosure obligations are upheld, even when their assignment is completed and the contractor no longer employs them.</p>
              </li>
              <li>
                <p>3.3 The contractor declares that he has taken all required steps to ensure that the security of the processing is upheld in accordance with Art. 32 GDPR (for specifications see appendix 1)</p>
              </li>
              <li>
                <p>3.4 The contractor implements the appropriate technical and organisational measures to that the client can comply with the rights of the affected individuals as per chapter III of the GDPR (information, access, rectification and erasure, data portability, objection as well as automated individual decision-making) as any time and within the legal deadlines and will submit all necessary information to the client. Should a relevant request be sent to the contractor and should this request show that the sender of the request mistakenly considers him the controller of the processing operated by the contractor, then the contractor must forward this request to the client without delay and notify the sender of the above.</p>
              </li>
              <li>
                <p>3.5 The contractor supports the client with adhering to the obligations, as outlined in Art. 32 to 36 GDPR (data security, notification of a personal data breach to the supervisory authority, communication of a personal data breach to the data subject, data protection impact assessment, prior consultation).</p>
              </li>
              <li>
                <p>3.6 The contractor is made aware that he must maintain a record of processing activities for the data processing in question in accordance with Art. 30 GDPR.</p>
              </li>
              <li>
                <p>3.7 With regard to the provided data, the client is entitled to view and check the data processing facilities at any, whether in person or via a commissioned third party. The contractor is obligated to provide the client with all necessary information to monitor the compliance with the obligations as outlined in this agreement.</p>
              </li>
              <li>
                <p>3.8 Following the termination of this agreement, the contractor is obligated to destroy, at his request, all processing results and documents that contain data.</p>
              </li>
              <li>
                <p>3.9 The contractor must inform the client immediately, if he is of the opinion that an instruction of the client constitues a violation of the data protection regulations of the Union or of the Member States.</p>
              </li>
            </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>4. Place of performance of data processing</strong></span>
            <p>Data processing is, at least in part, also executed outside of the EU or the EEA, namely in the USA. The appropriate data protection level is established on the basis of an adequacy decision by the European Commission in accordance with Art 45. GDPR.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>5. Sub-Processors</strong></span>
            <ul style="list-style-type:none;">
              <li>
                <p>5.1. The contractor can employ sub-processors. He must inform the client of the planned use of a sub-processor in such a timely manner, that the client can forbit it. The contractor enters into an arrangement with the sub-processor in accordance with Art. 28 para. 4 GDPR. In doing so, he must ensure that the sub-processor adheres to the same abligations as the contractor, with regard to this agreement. Should the sub-processor not comply with his data protection obligations, then the contractor is liable vis-a-vis the client for the compliance with obligations of the sub-processor.</p>
              </li>
            </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align:start;">
            <span style="font-size:30px; font-weight:bold;"><strong>Appendix 1 - Technical-organizational measures</strong></span>
            <p><strong>A. Confidentiality</strong></p>
            <p>Entry control: Avoidance of unauthorized entry to data processing facilities by Key, electric door opener, video surveilance, Follow-up of visitors on company premises</p>
            <p>Access control: Password (including relevant policies), Encryption of data carriers, Automated locking mechanisms, Two-factor authentication.</p>
            <p>Avoidance of unauthorized reading, copying, changing or deleting within the system through: Standard authorizations, Safe storage of data carriers, Regular checks of the assigned authorizations and of administrative user accounts in particular, Privacy-compliant reuse of data carriers, Privacy-compliant disposal of data carriers that are no longer needed.</p>
            <p>Pseudonymization: If possible for the data processing operation, the primary identifiers are remove from within the data processing operation and saved elsewhere.</p>
            <p>Data classification scheme: Based on legal obligations or self-assessment (secret/confidential/internal/public).</p>
            <p><strong>B. Data Integrity</strong></p>
            <p>Control of data transfer: No unauthorized reading, copying, changing or deleting during electronic transfer or transport by way of: Encryption of data carriers, Encryption of data transmissions.</p>
            <p>Data entry control: Determination of whether and by whom personal data has been entered into the data processing system, changed or deleted by: Logging, Document management.</p>
            <p><strong>C. Availablity and Resilience</strong></p>
            <p>Availablity control: Protection against wilful destruction (negligent and/or wilful) or loss through: Back-up strategy (online/offline; on-site/off-site).</p>
            <p>Rapid recoverability ensured.</p>
            <p><strong>D. Procedures for regular testing, assessing and evaluating</strong></p>
            <p>Data protection management, including regular employee training courses.</p>
            <p>Incidnet response management.</p>
            <p>Data protection by design.</p>
            <p>Data processing control: No data processing in the sense of Art 28 GDPR without specific instruction by the client through definitive contract design.</p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

export default {
  name: "DataProcessingAgreement",
  components: {
  },
  props: {
  },
  data() {
    return {
      origin: 'http://localhost:8080',
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  mounted: function () {
  },
  methods: {
    
  },
};
</script>